(function (global) {
  'use strict';

  var VERSION = '1.1.0';
  var STEP_COUNT = 5;
  var COLLECTION_LABELS = {
    freeride_snowboard: 'Freeride Snowboard',
    freestyle_snowboard: 'Freestyle Snowboard',
    carving_snowboard: 'Carving Snowboard',
    youth_snowboard: 'Youth Snowboard',
    splitboard: 'Splitboard',
    ski: 'Skis'
  };
  var GENERIC_CONSTRUCTION_HANDOFF_VALUES = {
    biaxial_fiberglass: 'Fiberglass',
    triaxial_fiberglass: 'Fiberglass',
    carbon: 'Carbon Fiber',
    titanal_fiberglass: 'Fiberglass',
    titanal_carbon: 'Carbon Fiber',
    race: 'Race Construction'
  };
  var SHAPE_CONSTRUCTION_HANDOFF_VALUES = {
    Delta: {
      triaxial_fiberglass: 'Triaxial Fiberglass',
      titanal_carbon: 'Titanal Reinforced Carbon',
      race: 'Race Construction'
    },
    'One Eyed Jack': {
      triaxial_fiberglass: 'Triaxial Fiberglass',
      titanal_carbon: 'Titanal Reinforced Carbon',
      race: 'Race Construction'
    }
  };

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function first(root, selector) {
    return root.querySelector(selector);
  }

  function readConfig(root) {
    var source = first(root, '[data-kindred-advisor-config]');
    if (!source) return {};
    try {
      return JSON.parse(source.textContent || '{}');
    } catch (error) {
      if (global.console && typeof global.console.warn === 'function') {
        global.console.warn('Kindred shape and size advisor ignored invalid configuration.', error);
      }
      return {};
    }
  }

  function readRadio(root, key) {
    var input = first(root, '[data-advisor-field="' + key + '"]:checked');
    return input ? input.value : '';
  }

  function readValue(root, key) {
    var input = first(root, '[data-advisor-field="' + key + '"]');
    return input ? input.value : '';
  }

  function selectedPriorities(root) {
    return all(root, '[data-advisor-field="priorities"]:checked').map(function (input) {
      return input.value;
    });
  }

  function productType(collection) {
    if (collection === 'splitboard') return 'splitboard';
    if (collection === 'ski') return 'skis';
    return 'snowboard';
  }

  function profileCategory(collection) {
    if (collection === 'splitboard') return 'splitboard';
    if (collection === 'ski') return 'ski';
    return 'snowboard';
  }

  function stateFrom(root) {
    var collection = readRadio(root, 'collection');
    var unit = root.getAttribute('data-units') || 'metric';
    return {
      collection: collection,
      product_type: productType(collection),
      unit: unit,
      height: readValue(root, 'height'),
      height_feet: readValue(root, 'height_feet'),
      height_inches: readValue(root, 'height_inches'),
      weight: readValue(root, 'weight'),
      boot_size_unit: readValue(root, 'boot_size_unit') || 'mens_us',
      boot_size: readValue(root, 'boot_size'),
      ability: readRadio(root, 'ability'),
      terrain: readRadio(root, 'terrain'),
      snow: readRadio(root, 'snow'),
      turn_style: readRadio(root, 'turn_style'),
      responsiveness: readRadio(root, 'responsiveness'),
      ride_feel: readRadio(root, 'ride_feel'),
      touring_focus: readRadio(root, 'touring_focus'),
      ski_touring_notch: readRadio(root, 'ski_touring_notch'),
      priorities: selectedPriorities(root)
    };
  }

  function numberValue(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function heightCentimetres(state) {
    if (state.unit !== 'imperial') return numberValue(state.height);
    return ((numberValue(state.height_feet) || 0) * 12 + (numberValue(state.height_inches) || 0)) * 2.54;
  }

  function weightKilograms(state) {
    var weight = numberValue(state.weight);
    return state.unit === 'imperial' ? weight * 0.45359237 : weight;
  }

  function setStatus(root, message) {
    var panel = first(root, '[data-advisor-step="' + String(root._kindredAdvisorStep || 0) + '"]');
    var status = panel ? first(panel, '[data-advisor-validation]') : first(root, '[data-advisor-validation]');
    if (status) status.textContent = message || '';
  }

  function collectionTerrainCategory(collection) {
    return collection === 'splitboard' ? 'splitboard' : 'snowboard';
  }

  function updateConditionalQuestions(root) {
    var collection = readRadio(root, 'collection');
    var terrainCategory = collectionTerrainCategory(collection);
    all(root, '[data-advisor-terrain]').forEach(function (option) {
      var visible = option.getAttribute('data-advisor-terrain') === terrainCategory;
      option.hidden = !visible;
      var input = option.querySelector('input');
      if (!visible && input) input.checked = false;
    });
    all(root, '[data-advisor-conditional]').forEach(function (question) {
      var visibleFor = String(question.getAttribute('data-advisor-conditional') || '').split(',');
      var visible = visibleFor.indexOf(collection) !== -1;
      question.hidden = !visible;
      if (!visible) {
        all(question, 'input').forEach(function (input) { input.checked = false; });
      }
    });
  }

  function fitSummary(state) {
    var height = heightCentimetres(state);
    var weight = weightKilograms(state);
    if (!Number.isFinite(height) || !Number.isFinite(weight) || !state.boot_size) return 'Not completed';
    var heightText = state.unit === 'imperial'
      ? state.height_feet + '′ ' + state.height_inches + '″'
      : Math.round(height * 10) / 10 + ' cm';
    var weightText = state.unit === 'imperial'
      ? Math.round(numberValue(state.weight) * 10) / 10 + ' lb'
      : Math.round(weight * 10) / 10 + ' kg';
    return heightText + ' · ' + weightText + ' · boot ' + state.boot_size;
  }

  function goalsComplete(state) {
    return Boolean(
      state.terrain && state.snow && state.turn_style && state.responsiveness &&
      state.ride_feel && state.priorities.length &&
      (state.collection !== 'splitboard' || state.touring_focus) &&
      (state.collection !== 'ski' || state.ski_touring_notch)
    );
  }

  function updateSummaries(root) {
    var state = stateFrom(root);
    var values = {
      0: COLLECTION_LABELS[state.collection] || 'Not selected',
      1: fitSummary(state),
      2: goalsComplete(state) ? 'Complete' : 'Not completed',
      3: root._kindredAdvisorSelection
        ? root._kindredAdvisorSelection.shape + ' · ' + root._kindredAdvisorSelection.size + ' cm'
        : 'Not selected',
      4: root._kindredAdvisorSelection && root._kindredAdvisorSelection.construction && root._kindredAdvisorSelection.flex
        ? root._kindredAdvisorSelection.constructionLabel + ' · ' + root._kindredAdvisorSelection.flexLabel
        : 'Not selected'
    };
    all(root, '[data-selection-summary-step]').forEach(function (item) {
      var index = Number(item.getAttribute('data-selection-summary-step'));
      var value = first(item, '[data-selection-summary-value]');
      if (value) value.textContent = values[index] || 'Not completed';
      var complete = index < root._kindredAdvisorStep && values[index] !== 'Not selected' && values[index] !== 'Not completed';
      item.setAttribute('data-summary-status', index === root._kindredAdvisorStep ? 'current' : (complete ? 'complete' : 'pending'));
    });
  }

  function showStep(root, nextStep, focusHeading) {
    var step = Math.max(0, Math.min(STEP_COUNT - 1, Number(nextStep) || 0));
    root._kindredAdvisorStep = step;
    all(root, '[data-advisor-step]').forEach(function (panel) {
      panel.hidden = Number(panel.getAttribute('data-advisor-step')) !== step;
    });
    all(root, '[data-progress-step]').forEach(function (item) {
      var index = Number(item.getAttribute('data-progress-step'));
      item.classList.toggle('is-complete', index < step);
      if (index === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
    var bar = first(root, '[data-progress-bar]');
    if (bar) bar.style.width = (((step + 1) / STEP_COUNT) * 100) + '%';
    all(root, '[data-progress-back]').forEach(function (button) { button.disabled = step === 0; });
    all(root, '[data-progress-next]').forEach(function (button) { button.disabled = step === STEP_COUNT - 1; });
    updateSummaries(root);
    setStatus(root, '');
    if (focusHeading !== false) {
      var heading = first(root, '[data-advisor-step="' + step + '"] h3');
      if (heading) heading.focus({ preventScroll: true });
      var wizard = first(root, '[data-advisor-wizard]');
      if (wizard && typeof wizard.scrollIntoView === 'function') wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function validateStep(root, step) {
    var state = stateFrom(root);
    if (step === 0 && !state.collection) {
      setStatus(root, 'Choose a product collection to continue.');
      return false;
    }
    if (step === 1) {
      var height = heightCentimetres(state);
      var weight = weightKilograms(state);
      var bootMatch = String(state.boot_size).match(/\d+(?:\.\d+)?/);
      var boot = bootMatch ? numberValue(bootMatch[0]) : NaN;
      if (!Number.isFinite(height) || height < 100 || height > 230 || !Number.isFinite(weight) || weight < 20 || weight > 230 || !Number.isFinite(boot) || !state.ability) {
        setStatus(root, 'Enter a valid height, riding weight and boot size, then choose an ability level.');
        return false;
      }
    }
    if (step === 2) {
      if (!state.terrain || !state.snow || !state.turn_style || !state.responsiveness || !state.ride_feel) {
        setStatus(root, 'Complete each ride-goal question to see your recommendations.');
        return false;
      }
      if (state.priorities.length < 1 || state.priorities.length > 3) {
        setStatus(root, 'Choose between one and three top priorities.');
        return false;
      }
      if (state.collection === 'splitboard' && !readRadio(root, 'touring_focus')) {
        setStatus(root, 'Choose a touring emphasis to continue.');
        return false;
      }
      if (state.collection === 'ski' && !readRadio(root, 'ski_touring_notch')) {
        setStatus(root, 'Choose a touring-notch preference to continue.');
        return false;
      }
    }
    if (step === 3) {
      if (!root._kindredAdvisorSelection || !root._kindredAdvisorSelection.shape || !root._kindredAdvisorSelection.size) {
        setStatus(root, 'Choose a shape and stock size to continue.');
        return false;
      }
      if (!root._kindredAdvisorSelection.destination) {
        setStatus(root, 'That product page is temporarily unavailable. Please choose another match.');
        return false;
      }
    }
    if (step === 4 && (!root._kindredAdvisorSelection || !root._kindredAdvisorSelection.construction || !root._kindredAdvisorSelection.flex)) {
      var missingConstruction = !root._kindredAdvisorSelection || !root._kindredAdvisorSelection.construction;
      var missingFlex = !root._kindredAdvisorSelection || !root._kindredAdvisorSelection.flex;
      setStatus(root, missingConstruction && missingFlex
        ? 'Choose a construction and flex pattern to continue.'
        : (missingConstruction ? 'Choose a construction to continue.' : 'Choose a flex pattern to continue.'));
      var missingInput = first(root, missingConstruction ? '[data-advisor-construction]' : '[data-advisor-flex]');
      if (missingInput) missingInput.focus({ preventScroll: true });
      return false;
    }
    setStatus(root, '');
    return true;
  }

  function normalizeDestination(entry) {
    if (typeof entry === 'string') return { url: entry, productId: '' };
    if (!entry || typeof entry !== 'object') return { url: '', productId: '' };
    return {
      url: String(entry.url || ''),
      productId: String(entry.productId || entry.product_id || '')
    };
  }

  function resultCard(root, option, index, config, state) {
    var category = profileCategory(state.collection);
    var destination = normalizeDestination((config.productDestinations || {})[category + ':' + option.name]);
    var card = document.createElement('article');
    card.className = 'kcb-shape-choice ksa-result-card';
    card.setAttribute('data-advisor-result-card', '');
    card.setAttribute('data-shape', option.name);
    card.setAttribute('data-destination', destination.url);
    card.setAttribute('data-product-id', destination.productId);

    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'kindred-advisor-result-' + String(config.sectionId || 'section');
    input.value = option.name;
    input.id = 'KindredAdvisorResult-' + String(config.sectionId || 'section') + '-' + index;
    input.setAttribute('data-advisor-result-choice', '');
    if (index === 0) input.checked = true;

    var visual = document.createElement('span');
    visual.className = 'kcb-shape-choice-visual';
    if (option.image) {
      var image = document.createElement('img');
      image.src = option.image;
      image.alt = 'Kindred ' + option.name + ' shape';
      image.loading = index === 0 ? 'eager' : 'lazy';
      visual.appendChild(image);
    }

    var body = document.createElement('span');
    body.className = 'kcb-shape-choice-body';
    var heading = document.createElement('span');
    heading.className = 'kcb-shape-choice-heading';
    var titleBlock = document.createElement('span');
    titleBlock.className = 'kcb-shape-choice-title-block';
    var title = document.createElement('label');
    title.className = 'kcb-option-title';
    title.htmlFor = input.id;
    title.textContent = option.name;
    var match = document.createElement('small');
    match.textContent = index === 0 ? 'Best match' : 'Match ' + (index + 1);
    titleBlock.appendChild(title);
    heading.appendChild(titleBlock);
    heading.appendChild(match);

    var specs = document.createElement('span');
    specs.className = 'kcb-shape-choice-specs';
    specs.id = input.id + '-specs';
    var sizeSpec = document.createElement('small');
    sizeSpec.textContent = 'Suggested size: ' + (option.stockLength || '—') + ' cm';
    var fitSpec = document.createElement('small');
    fitSpec.textContent = option.isClosestStockOption ? 'Fit: closest stock option' : 'Fit: recommended range';
    var profileSpec = document.createElement('small');
    profileSpec.textContent = 'Profile: ' + (option.profile || 'See product details');
    var scoreSpec = document.createElement('small');
    scoreSpec.textContent = 'Size fit: ' + Math.round(Number(option.sizeFitScore) || 0) + '%';
    specs.appendChild(sizeSpec);
    specs.appendChild(fitSpec);
    specs.appendChild(profileSpec);
    specs.appendChild(scoreSpec);

    var description = document.createElement('span');
    description.className = 'kcb-option-description';
    description.id = input.id + '-description';
    description.textContent = option.summary || 'A stock Kindred shape matched to your measurements and ride goals.';
    input.setAttribute('aria-describedby', specs.id + ' ' + description.id);

    var sizeLabel = document.createElement('label');
    sizeLabel.className = 'ksa-size-select';
    sizeLabel.appendChild(document.createTextNode('Choose size'));
    var select = document.createElement('select');
    select.setAttribute('data-advisor-size', '');
    (option.availableLengths || []).forEach(function (length) {
      var item = document.createElement('option');
      item.value = String(length);
      item.textContent = String(length) + ' cm';
      item.selected = Number(length) === Number(option.stockLength);
      select.appendChild(item);
    });
    sizeLabel.appendChild(select);

    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'kcb-button kcb-button--primary ksa-view-button';
    action.setAttribute('data-advisor-choose-shape', '');
    action.disabled = !destination.url || !option.stockLength;
    action.textContent = destination.url ? 'Choose ' + option.name + ' →' : option.name + ' page unavailable';

    body.appendChild(heading);
    body.appendChild(specs);
    body.appendChild(description);
    body.appendChild(sizeLabel);
    body.appendChild(action);
    card.appendChild(input);
    card.appendChild(visual);
    card.appendChild(body);
    return card;
  }

  function selectResult(root, card) {
    all(root, '[data-advisor-result-card]').forEach(function (item) {
      var selected = item === card;
      item.classList.toggle('is-selected', selected);
      var radio = first(item, '[data-advisor-result-choice]');
      if (radio) radio.checked = selected;
    });
    var size = first(card, '[data-advisor-size]');
    var shape = card.getAttribute('data-shape') || '';
    var sizeValue = size ? size.value : '';
    var previous = root._kindredAdvisorSelection;
    var sameProduct = previous && previous.shape === shape && previous.size === sizeValue;
    var visual = first(card, '.kcb-shape-choice-visual img');
    root._kindredAdvisorSelection = {
      shape: shape,
      size: sizeValue,
      destination: card.getAttribute('data-destination') || '',
      productId: card.getAttribute('data-product-id') || '',
      image: visual ? visual.src : '',
      construction: sameProduct ? previous.construction : '',
      constructionLabel: sameProduct ? previous.constructionLabel : '',
      constructionValue: sameProduct ? previous.constructionValue : '',
      flex: sameProduct ? previous.flex : '',
      flexLabel: sameProduct ? previous.flexLabel : ''
    };
    updateSummaries(root);
  }

  function renderResults(root) {
    var api = global.KindredCustomBuildIntake;
    var config = root._kindredAdvisorConfig || {};
    var container = first(root, '[data-advisor-results]');
    if (!api || typeof api.recommendStock !== 'function' || !container) {
      setStatus(root, 'Recommendations are temporarily unavailable. Please try again.');
      return false;
    }
    var state = stateFrom(root);
    var recommendation = api.recommendStock(state, config);
    container.replaceChildren();
    if (!recommendation.stockOptions.length) {
      setStatus(root, 'No stock match is currently available for this collection.');
      return false;
    }
    recommendation.stockOptions.forEach(function (option, index) {
      container.appendChild(resultCard(root, option, index, config, state));
    });
    var firstCard = first(container, '[data-advisor-result-card]');
    if (firstCard) selectResult(root, firstCard);
    var count = first(root, '[data-advisor-result-count]');
    if (count) {
      count.textContent = recommendation.stockOptions.length === 3
        ? 'Your three closest stock matches'
        : 'Every stock match available in this collection';
    }
    return true;
  }

  function optionLabel(api, group, key) {
    if (api && typeof api.label === 'function') return api.label(group, key);
    return String(key || '').replace(/_/g, ' ').replace(/\b\w/g, function (character) { return character.toUpperCase(); });
  }

  function constructionHandoffValue(shape, key) {
    var shapeValues = SHAPE_CONSTRUCTION_HANDOFF_VALUES[shape] || {};
    return shapeValues[key] || GENERIC_CONSTRUCTION_HANDOFF_VALUES[key] || '';
  }

  function buildState(root) {
    var selection = root._kindredAdvisorSelection || {};
    return Object.assign({}, stateFrom(root), {
      shape_choice: selection.shape || '',
      shape_selection: selection.shape || '',
      stock_length: selection.size || ''
    });
  }

  function flexEffect(key, shape) {
    var subject = shape || 'the selected shape';
    var effects = {
      soft: 'Makes ' + subject + ' easier to bend and initiate, with a more forgiving response and less support under heavier loads.',
      standard: 'Preserves the balanced flex progression of ' + subject + ', combining predictable turn initiation, dependable support and controlled rebound.',
      stiff: 'Adds support and rebound to ' + subject + ', improving composure at speed and under load while requiring more rider input.'
    };
    return effects[key] || '';
  }

  function optionCard(config, group, option, suggestedKey, selectedKey) {
    var label = document.createElement('label');
    label.className = 'kcb-option ksa-build-option';
    label.classList.toggle('is-recommended', option.key === suggestedKey);
    label.classList.toggle('is-selected', option.key === selectedKey);

    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'kindred-advisor-' + group + '-' + String(config.sectionId || 'section');
    input.value = option.key;
    input.setAttribute('data-advisor-' + group, '');
    input.checked = option.key === selectedKey;

    var body = document.createElement('span');
    var title = document.createElement('strong');
    title.className = 'kcb-option-title';
    title.textContent = option.label;
    var badge = document.createElement('span');
    badge.className = 'kcb-recommended-badge';
    badge.textContent = 'Suggested';
    badge.hidden = option.key !== suggestedKey;
    var description = document.createElement('small');
    description.className = 'kcb-option-description';
    description.textContent = option.description || '';
    body.appendChild(title);
    body.appendChild(badge);
    body.appendChild(description);
    label.appendChild(input);
    label.appendChild(body);
    return label;
  }

  function syncBuildOptionSelection(root, selector, selectedKey) {
    all(root, selector).forEach(function (input) {
      var selected = input.value === selectedKey;
      input.checked = selected;
      var option = input.closest('.kcb-option');
      if (option) option.classList.toggle('is-selected', selected);
    });
  }

  function renderConstructionDetails(root, details) {
    var panel = first(root, '[data-advisor-construction-details]');
    if (!panel) return;
    if (!details) {
      panel.hidden = true;
      return;
    }
    panel.hidden = false;
    panel.setAttribute('data-construction-key', details.key || '');
    var title = first(panel, '[data-advisor-construction-title]');
    var summary = first(panel, '[data-advisor-construction-summary]');
    var factors = first(panel, '[data-advisor-construction-factors]');
    var best = first(panel, '[data-advisor-construction-best]');
    var tradeoff = first(panel, '[data-advisor-construction-tradeoff]');
    var note = first(panel, '[data-advisor-construction-note]');
    if (title) title.textContent = details.title || '';
    if (summary) summary.textContent = details.summary || '';
    if (factors) {
      factors.replaceChildren();
      (details.factors || []).forEach(function (factor) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var value = document.createElement('dd');
        term.textContent = factor.label || '';
        value.textContent = factor.value || '';
        row.appendChild(term);
        row.appendChild(value);
        factors.appendChild(row);
      });
    }
    if (best) best.textContent = details.best || '';
    if (tradeoff) tradeoff.textContent = details.tradeoff || '';
    if (note) note.textContent = details.note || '';
  }

  function renderFlexDetails(root, flexData, selectedKey) {
    var panel = first(root, '[data-advisor-flex-details]');
    var option = flexData && (flexData.options || []).find(function (item) { return item.key === selectedKey; });
    if (!panel || !option) {
      if (panel) panel.hidden = true;
      return;
    }
    panel.hidden = false;
    panel.setAttribute('data-flex-key', option.key || '');
    var title = first(panel, '[data-advisor-flex-title]');
    var rating = first(panel, '[data-advisor-flex-rating]');
    var relative = first(panel, '[data-advisor-flex-relative]');
    var summary = first(panel, '[data-advisor-flex-summary]');
    var effect = first(panel, '[data-advisor-flex-effect]');
    var note = first(panel, '[data-advisor-flex-note]');
    if (title) title.textContent = option.label || '';
    if (rating) rating.textContent = Number.isFinite(option.intendedFlex) ? option.intendedFlex + '/10' : '—';
    if (relative) relative.textContent = option.label || '';
    if (summary) summary.textContent = option.detail || '';
    if (effect) effect.textContent = flexEffect(option.key, root._kindredAdvisorSelection && root._kindredAdvisorSelection.shape);
    if (note) {
      note.textContent = option.key === flexData.key
        ? flexData.reason || ''
        : 'Suggested flex: ' + flexData.label + ' ' + flexData.intendedFlex + '/10.';
    }
  }

  function updateBuildAction(root) {
    var selection = root._kindredAdvisorSelection || {};
    var button = first(root, '[data-advisor-open-product]');
    var complete = Boolean(selection.shape && selection.size && selection.construction && selection.constructionValue && selection.flex && selection.destination);
    if (button) {
      button.disabled = !selection.destination;
      button.textContent = complete
        ? 'Continue to ' + selection.shape + ' →'
        : 'Choose construction and flex to continue';
      button.setAttribute('aria-label', complete
        ? 'Continue to the ' + selection.shape + ' product page with the selected size, construction and flex'
        : 'Choose a construction and flex pattern before continuing to the product page');
    }
    if (complete) setStatus(root, '');
    updateSummaries(root);
  }

  function prepareBuildStep(root) {
    var api = global.KindredCustomBuildIntake;
    var config = root._kindredAdvisorConfig || {};
    var selection = root._kindredAdvisorSelection;
    var constructionContainer = first(root, '[data-advisor-construction-options]');
    var flexContainer = first(root, '[data-advisor-flex-options]');
    if (!api || !selection || !selection.shape || !selection.size || !constructionContainer || !flexContainer) return false;

    var state = buildState(root);
    var constructionKeys = typeof api.constructionOptionsForShape === 'function'
      ? api.constructionOptionsForShape(selection.shape, false, state.product_type)
      : ['triaxial_fiberglass', 'carbon'];
    var constructionSuggestion = typeof api.recommendComposite === 'function'
      ? api.recommendComposite(state)
      : { key: constructionKeys[0] || '' };
    var selectedConstruction = constructionKeys.indexOf(selection.construction) !== -1
      ? selection.construction
      : (constructionKeys.length === 1 ? constructionKeys[0] : '');
    constructionContainer.replaceChildren();
    constructionKeys.forEach(function (key) {
      var details = typeof api.constructionDetails === 'function' ? api.constructionDetails(key) : null;
      constructionContainer.appendChild(optionCard(config, 'construction', {
        key: key,
        label: optionLabel(api, 'construction', key),
        description: constructionKeys.length === 1
          ? 'Standard for this shape. ' + (details && details.summary ? details.summary : '')
          : (details && details.summary ? details.summary : 'Construction tuned to the selected shape.')
      }, constructionSuggestion.key, selectedConstruction));
    });

    var flexData = typeof api.flexPatternRecommendation === 'function'
      ? api.flexPatternRecommendation(selection.shape, selection.size, state)
      : null;
    var flexOptions = flexData && Array.isArray(flexData.options) ? flexData.options : [];
    var selectedFlex = flexOptions.some(function (option) { return option.key === selection.flex; }) ? selection.flex : '';
    flexContainer.replaceChildren();
    flexOptions.forEach(function (option) {
      flexContainer.appendChild(optionCard(config, 'flex', {
        key: option.key,
        label: option.label,
        description: Number.isFinite(option.intendedFlex) ? option.intendedFlex + '/10 · ' + option.detail : option.detail
      }, flexData.key, selectedFlex));
    });

    selection.construction = selectedConstruction;
    selection.constructionLabel = selectedConstruction ? optionLabel(api, 'construction', selectedConstruction) : '';
    selection.constructionValue = selectedConstruction ? constructionHandoffValue(selection.shape, selectedConstruction) : '';
    selection.flex = selectedFlex;
    selection.flexLabel = selectedFlex ? optionLabel(api, 'flex_pattern', selectedFlex) : '';
    root._kindredAdvisorBuildData = {
      constructionSuggestion: constructionSuggestion,
      constructionKeys: constructionKeys,
      flex: flexData
    };

    var product = first(root, '[data-advisor-build-product]');
    var image = first(root, '[data-advisor-build-image]');
    if (product) product.textContent = selection.shape + ' · ' + selection.size + ' cm';
    if (image) {
      image.hidden = !selection.image;
      if (selection.image) {
        image.src = selection.image;
        image.alt = 'Kindred ' + selection.shape + ' shape';
      }
    }
    renderConstructionDetails(root, selectedConstruction && typeof api.constructionDetails === 'function' ? api.constructionDetails(selectedConstruction) : null);
    renderFlexDetails(root, flexData, selectedFlex);
    updateBuildAction(root);
    return constructionKeys.length > 0 && flexOptions.length > 0;
  }

  function buildDestinationUrl(selection, baseHref) {
    selection = selection || {};
    if (!selection.destination || !selection.size || !selection.shape || !selection.constructionValue || !selection.flexLabel) return '';
    var url;
    try {
      url = new URL(selection.destination, baseHref);
    } catch {
      return '';
    }
    url.searchParams.set('kindred_handoff', '1');
    url.searchParams.set('kindred_shape', selection.shape);
    url.searchParams.set('kindred_size', selection.size);
    url.searchParams.set('kindred_construction', selection.constructionValue);
    url.searchParams.set('kindred_flex', selection.flexLabel);
    if (selection.productId) url.searchParams.set('kindred_product_id', selection.productId);
    url.hash = 'kindred-product-options';
    return url.href;
  }

  function destinationUrl(root) {
    return buildDestinationUrl(root._kindredAdvisorSelection, global.location.href);
  }

  function setUnits(root, next) {
    var current = root.getAttribute('data-units') || 'metric';
    if (next === current) return;
    var heightMetric = first(root, '[data-advisor-field="height"]');
    var heightFeet = first(root, '[data-advisor-field="height_feet"]');
    var heightInches = first(root, '[data-advisor-field="height_inches"]');
    var weight = first(root, '[data-advisor-field="weight"]');
    if (next === 'imperial') {
      var centimetres = numberValue(heightMetric && heightMetric.value);
      if (Number.isFinite(centimetres) && heightFeet && heightInches) {
        var totalInches = centimetres / 2.54;
        heightFeet.value = String(Math.floor(totalInches / 12));
        heightInches.value = String(Math.round((totalInches % 12) * 2) / 2);
      }
      var kilograms = numberValue(weight && weight.value);
      if (weight && Number.isFinite(kilograms)) weight.value = String(Math.round(kilograms * 2.2046226218));
    } else {
      var feet = numberValue(heightFeet && heightFeet.value);
      var inches = numberValue(heightInches && heightInches.value);
      if (heightMetric && (Number.isFinite(feet) || Number.isFinite(inches))) {
        heightMetric.value = String(Math.round((((feet || 0) * 12 + (inches || 0)) * 2.54) * 2) / 2);
      }
      var pounds = numberValue(weight && weight.value);
      if (weight && Number.isFinite(pounds)) weight.value = String(Math.round((pounds / 2.2046226218) * 2) / 2);
    }
    root.setAttribute('data-units', next);
    all(root, '[data-unit]').forEach(function (button) {
      var active = button.getAttribute('data-unit') === next;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var metricHeight = first(root, '[data-advisor-height-metric]');
    var imperialHeight = first(root, '[data-advisor-height-imperial]');
    if (metricHeight) metricHeight.hidden = next !== 'metric';
    if (imperialHeight) imperialHeight.hidden = next !== 'imperial';
    var weightLegend = first(root, '[data-advisor-weight-legend]');
    var weightUnit = first(root, '[data-advisor-weight-unit]');
    if (weightLegend) weightLegend.textContent = next === 'metric' ? 'Weight (kg)' : 'Weight (lb)';
    if (weightUnit) weightUnit.textContent = next === 'metric' ? 'Kilograms' : 'Pounds';
    if (weight) {
      weight.placeholder = next === 'metric' ? '78' : '172';
      weight.min = next === 'metric' ? '20' : '44';
      weight.max = next === 'metric' ? '230' : '507';
    }
    updateSummaries(root);
  }

  function rulesReady(root) {
    var api = global.KindredCustomBuildIntake;
    var config = root._kindredAdvisorConfig || {};
    if (!api) return Promise.reject(new Error('Recommendation engine unavailable.'));
    if (config.publishedRules !== undefined && config.publishedRules !== null) {
      var result = api.applyRulePayload(config.publishedRules);
      if (!result.ok && global.console && typeof global.console.warn === 'function') {
        global.console.warn('Kindred advisor kept its bundled rules because the published rules were invalid: ' + result.error);
      }
      return Promise.resolve();
    }
    if (!config.shapePrioritiesEndpoint) return Promise.resolve();
    return fetch(config.shapePrioritiesEndpoint, { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Editor rules could not be loaded.');
        return response.json();
      })
      .then(function (data) {
        var payload = {
          schema_version: api.rulesSchemaVersion,
          profiles: data.profiles,
          collection_shapes: data.collection_shapes,
          question_weights: data.question_weights,
          collection_question_weights: data.collection_question_weights
        };
        var result = api.applyRulePayload(payload);
        if (!result.ok) throw new Error(result.error || 'Editor rules were invalid.');
      })
      .catch(function (error) {
        if (global.console && typeof global.console.warn === 'function') {
          global.console.warn('Kindred advisor is using its bundled rules.', error);
        }
      });
  }

  function reset(root) {
    var form = first(root, '[data-advisor-form]');
    if (form) form.reset();
    root._kindredAdvisorSelection = null;
    root._kindredAdvisorBuildData = null;
    var results = first(root, '[data-advisor-results]');
    if (results) results.replaceChildren();
    var constructionOptions = first(root, '[data-advisor-construction-options]');
    var flexOptions = first(root, '[data-advisor-flex-options]');
    if (constructionOptions) constructionOptions.replaceChildren();
    if (flexOptions) flexOptions.replaceChildren();
    renderConstructionDetails(root, null);
    renderFlexDetails(root, null, '');
    root.setAttribute('data-units', 'metric');
    var metricHeight = first(root, '[data-advisor-height-metric]');
    var imperialHeight = first(root, '[data-advisor-height-imperial]');
    if (metricHeight) metricHeight.hidden = false;
    if (imperialHeight) imperialHeight.hidden = true;
    var weightLegend = first(root, '[data-advisor-weight-legend]');
    var weightUnit = first(root, '[data-advisor-weight-unit]');
    var weight = first(root, '[data-advisor-field="weight"]');
    if (weightLegend) weightLegend.textContent = 'Weight (kg)';
    if (weightUnit) weightUnit.textContent = 'Kilograms';
    if (weight) {
      weight.placeholder = '78';
      weight.min = '20';
      weight.max = '230';
    }
    all(root, '[data-unit]').forEach(function (button) {
      var active = button.getAttribute('data-unit') === 'metric';
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateConditionalQuestions(root);
    showStep(root, 0, true);
  }

  function mountOne(root) {
    if (root.getAttribute('data-advisor-mounted') === 'true') return;
    root.setAttribute('data-advisor-mounted', 'true');
    root.classList.add('is-enhanced');
    root._kindredAdvisorStep = 0;
    root._kindredAdvisorSelection = null;
    root._kindredAdvisorBuildData = null;
    root._kindredAdvisorConfig = readConfig(root);
    root._kindredAdvisorReady = rulesReady(root);
    updateConditionalQuestions(root);

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.matches('[data-advisor-field="collection"]')) {
        updateConditionalQuestions(root);
        root._kindredAdvisorSelection = null;
      }
      if (target.matches('[data-advisor-field="priorities"]')) {
        var priorities = selectedPriorities(root);
        if (priorities.length > 3) {
          target.checked = false;
          setStatus(root, 'Choose up to three top priorities.');
        }
      }
      var card = target.closest('[data-advisor-result-card]');
      if (card && (target.matches('[data-advisor-result-choice]') || target.matches('[data-advisor-size]'))) {
        selectResult(root, card);
      }
      if (target.matches('[data-advisor-construction]')) {
        var construction = root._kindredAdvisorSelection;
        if (construction) {
          construction.construction = target.value;
          construction.constructionLabel = optionLabel(global.KindredCustomBuildIntake, 'construction', target.value);
          construction.constructionValue = constructionHandoffValue(construction.shape, target.value);
          syncBuildOptionSelection(root, '[data-advisor-construction]', target.value);
          renderConstructionDetails(root, global.KindredCustomBuildIntake.constructionDetails(target.value));
          updateBuildAction(root);
        }
      }
      if (target.matches('[data-advisor-flex]')) {
        var flex = root._kindredAdvisorSelection;
        if (flex) {
          flex.flex = target.value;
          flex.flexLabel = optionLabel(global.KindredCustomBuildIntake, 'flex_pattern', target.value);
          syncBuildOptionSelection(root, '[data-advisor-flex]', target.value);
          renderFlexDetails(root, root._kindredAdvisorBuildData && root._kindredAdvisorBuildData.flex, target.value);
          updateBuildAction(root);
        }
      }
      updateSummaries(root);
    });

    root.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var unitButton = target.closest('[data-unit]');
      if (unitButton && root.contains(unitButton)) {
        setUnits(root, unitButton.getAttribute('data-unit'));
        return;
      }
      var resetButton = target.closest('[data-advisor-start-over]');
      if (resetButton && root.contains(resetButton)) {
        reset(root);
        return;
      }
      var chooseButton = target.closest('[data-advisor-choose-shape]');
      if (chooseButton && root.contains(chooseButton)) {
        var choiceCard = chooseButton.closest('[data-advisor-result-card]');
        if (!choiceCard || chooseButton.disabled) return;
        selectResult(root, choiceCard);
        if (!validateStep(root, 3) || !prepareBuildStep(root)) {
          setStatus(root, 'Construction and flex choices are temporarily unavailable. Please choose another match.');
          return;
        }
        showStep(root, 4, true);
        return;
      }
      var openButton = target.closest('[data-advisor-open-product]');
      if (openButton && root.contains(openButton)) {
        if (openButton.disabled || !validateStep(root, 4)) return;
        var url = destinationUrl(root);
        if (!url) {
          setStatus(root, 'That product page is temporarily unavailable. Please review your selections and try again.');
          return;
        }
        openButton.disabled = true;
        openButton.textContent = 'Opening ' + (root._kindredAdvisorSelection.shape || 'product') + '…';
        global.location.assign(url);
        return;
      }
      var card = target.closest('[data-advisor-result-card]');
      if (card && root.contains(card) && !target.closest('button, select, a, input, label')) {
        var resultRadio = first(card, '[data-advisor-result-choice]');
        if (resultRadio) resultRadio.click();
        selectResult(root, card);
        return;
      }
      var backButton = target.closest('[data-advisor-back], [data-progress-back]');
      if (backButton && root.contains(backButton)) {
        showStep(root, root._kindredAdvisorStep - 1, true);
        return;
      }
      var nextButton = target.closest('[data-advisor-next], [data-progress-next]');
      if (!nextButton || !root.contains(nextButton) || root._kindredAdvisorStep >= STEP_COUNT - 1) return;
      if (!validateStep(root, root._kindredAdvisorStep)) return;
      if (root._kindredAdvisorStep === 2) {
        nextButton.disabled = true;
        setStatus(root, 'Finding your closest Kindred matches…');
        Promise.resolve(root._kindredAdvisorReady).then(function () {
          if (renderResults(root)) showStep(root, 3, true);
        }).catch(function () {
          setStatus(root, 'Recommendations are temporarily unavailable. Please try again.');
        }).finally(function () {
          nextButton.disabled = false;
        });
        return;
      }
      if (root._kindredAdvisorStep === 3) {
        if (!prepareBuildStep(root)) {
          setStatus(root, 'Construction and flex choices are temporarily unavailable. Please choose another match.');
          return;
        }
      }
      showStep(root, root._kindredAdvisorStep + 1, true);
    });

    showStep(root, 0, false);
  }

  function mount(scope) {
    if (typeof document === 'undefined') return;
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (context.matches && context.matches('[data-kindred-shape-size-advisor]')) roots.push(context);
    all(context, '[data-kindred-shape-size-advisor]').forEach(function (root) { roots.push(root); });
    roots.forEach(mountOne);
  }

  global.KindredShapeSizeAdvisor = {
    version: VERSION,
    mount: mount
  };
  global.KindredShapeSizeAdvisorTest = {
    buildDestinationUrl: buildDestinationUrl,
    constructionHandoffValue: constructionHandoffValue
  };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
    else mount(document);
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
